export default __webpack_public_path__ + "telkom-property.png";